import { gql } from '@apollo/client'

export default gql(`
    query($filter: BucketGroupTypeFilterInput $limit: Int $project: String){
        listBucketGroupType( 
            filter: $filter
            limit: $limit
            project: $project
        ) {
        items {
            id
            name
            position
            usedCount
        }
    }
}`)
